<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card>
      <h3 class="tw-text-xl tw-font-thin">Edit Activity Type</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-text-field label="Label" type="text" placeholder="Enter a label for the activity type" v-model="todoItemType.label" @keyup.enter="submit" required></base-text-field>
        <base-textarea label="Description" placeholder="Enter a description" v-model="todoItemType.description" @keyup.enter="submit" required></base-textarea>
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error class="tw-mt-3" id="edit-activity-type-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";

export default {
  name: "EditTodoItemType",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      todoItemType: { label: null, description: null, target: "member" },
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.todoItemType = { label: null, description: null, target: "member" };
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.$refs.form.reset();
    },
    show(todoItemType) {
      this.todoItemType = todoItemType;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/todo/types/${this.todoItemType.todoItemTypeId}`, {
          label: this.todoItemType.label,
          description: this.todoItemType.description,
          target: this.todoItemType.target,
        })
        .then(() => {
          this.$emit("typesUpdated", {});
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Activity Type Modified", message: `Your activity type was saved.` });
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error creating activity type`;
          this.errorMessage = "Sorry, we had trouble changing this activity type. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
